import { createReducer, createAction, combineReducers } from "@reduxjs/toolkit";

const selectedItem: string = "";

type stringAction = {
  type: string;
  payload: string;
};

type numberAction = {
  type: string;
  payload: number;
};

export const actionNames = {
  selectItem: "SELECT_ITEM",
  updateList: "UPDATE_LIST",
  selectWallet: "SELECT_WALLET",
  balance: "BALANCE",
  balanceRequestAge: "BALANCE_REQUEST_AGE",
  whitelistTrigger: "WHITELIST_TRIGGER",
};

export const actions = {
  SelectItem: createAction<string>(actionNames.selectItem),
  setBalance: createAction<string | null>(actionNames.balance),
  setBalanceAge: createAction<number>(actionNames.balanceRequestAge),
  whitelistTrigger: createAction<string>(actionNames.whitelistTrigger),
};

const ItemSelector = (state = selectedItem, action: stringAction) => {
  const newState =
    action.type === actionNames.selectItem ? action.payload : state;
  return newState;
};

const updateBalance = (state = null, action: stringAction) => {
  const newState = action.type === actionNames.balance ? action.payload : state;
  return newState;
};

const updateBalanceAge = (state = 0, action: numberAction) => {
  const newState = action.type === actionNames.balance ? action.payload : state;
  return newState;
};

const whitelistTrigger = (state = "", action: stringAction) => {
  const newState =
    action.type === actionNames.whitelistTrigger ? action.payload : state;
  return newState;
};

export const RootReducer = combineReducers({
  selectedItem: ItemSelector,
  balance: updateBalance,
  balanceAge: updateBalanceAge,
  whitelistTrigger: whitelistTrigger,
});

export type RootState = ReturnType<typeof RootReducer>;
